import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import {
  GET_USER,
  GET_USERS_BY_ID,
  ADD_USER,
  GET_AUTHOR,
  GET_CRAFTSMAN,
  ON_CHECKED_AUTHOR,
  ON_CHECKED_CRAFTSMAN,
  UPDATE_USER,
  SET_CRAFTSMAN,
} from "./actionTypes"

//Include Both Helper File with needed methods
import {
  getUsersAPI,
  getUsersByIdAPI,
  getUsersAuthorAPI,
  getUsersCraftsmanAPI,
  postUsersAPI,
  putUsersAPI,
} from "helpers/users_backend_helper"
import {
  getUserSuccess,
  getUSersFail,
  startFetchUser,
  getCraftsmanSuccess,
  getAuthorSuccess,
  getUserByIdSuccess,
  addUsersError,
} from "./actions"
import debounce from "debounce-promise"
const debounceGetUsersAPI = debounce(getUsersAPI, 1000)

// get global state
export const getState = ({ Users }) => Users

function* fetchUsers(args) {
  yield put(startFetchUser())
  try {
    let { data } = yield call(debounceGetUsersAPI, args.args)
    yield put(getUserSuccess(data))
  } catch (error) {
    yield put(getUSersFail(error?.response))
  }
}

function* fetchUsersById(args) {
  try {
    let { data } = yield call(getUsersByIdAPI, args.id)
    yield put(getUserByIdSuccess(data))

    let store = yield select(getState)
    let author = [...store.author]
    author.map(item => {
      if (item.label === data.authority) {
        item.isChecked = true
      }
    })
    let craftsman = [...store.craftsman]
    craftsman.map(item => {
      let unique = data.craftsmanTypes.find(a => a === item.label)
      if (item.label === unique) {
        item.isChecked = true
      } else {
        item.isChecked = false
      }
    })
    yield put(getCraftsmanSuccess(craftsman))
    yield put(getAuthorSuccess(author))
  } catch (error) {
    console.log(error.response)
  }
}

function* updateUsersById(args) {
  try {
    yield call(putUsersAPI, args.args.data, args.args.id)
    yield put(getUserByIdSuccess({}))
    args.toggle()
  } catch (error) {
    yield put(addUsersError(error.response?.data))
    if (error.response.status === 400) {
      error.response.data.errors.forEach(item => {
        let entries = Object.entries(item)
        entries.map(([key, val] = entry) => {
          return toast.error(`The ${key} is ${val}`)
        })
      })
    }
  }
}

function* fetchAuthor() {
  try {
    let { data } = yield call(getUsersAuthorAPI)
    let _author = []
    data.map(item => {
      _author.push({ label: item, isChecked: false })
    })
    yield put(getAuthorSuccess(_author))
  } catch (error) {
    console.log("error: ", error.response)
  }
}

function* checkedAuthor(args) {
  let store = yield select(getState)
  let author = [...store.author]
  author.map((item, index) => {
    if (index === args.args.index) {
      item.isChecked = true
    } else {
      item.isChecked = false
    }
  })
  yield put(getAuthorSuccess(author))
}

function* checkedCraftsman(args) {
  let store = yield select(getState)
  let craftsman = [...store.craftsman]
  craftsman[args.args.index].isChecked = !craftsman[args.args.index].isChecked
  yield put(getCraftsmanSuccess(craftsman))
}

function* setCraftsmanSaga(args) {
  let store = yield select(getState)
  let craftsman = [...store.craftsman]
  craftsman.map(item => {
    let unique = args.args.find(a => a === item.label)
    if (item.label === unique) {
      item.isChecked = true
    } else {
      item.isChecked = false
    }
  })
  // console.log("craftsman: ", craftsman)
  // console.log("args: ", args)
  yield put(getCraftsmanSuccess(craftsman))
}

function* fetchCraftsman() {
  try {
    let { data } = yield call(getUsersCraftsmanAPI)
    let _craftsman = []
    data.map(item => {
      _craftsman.push({ label: item, isChecked: false })
    })
    yield put(getCraftsmanSuccess(_craftsman))
  } catch (error) {
    console.log(error.response)
  }
}

function* createUsers(data) {
  try {
    yield call(postUsersAPI, data.data)
    data.toggle()
  } catch (error) {
    yield put(addUsersError(error.response?.data))
    if (error.response.status === 400) {
      error.response.data.errors.forEach(item => {
        let entries = Object.entries(item)
        entries.map(([key, val] = entry) => {
          return toast.error(`The ${key} is ${val}`)
        })
      })
    }
  }
}

function* usersSaga() {
  yield takeEvery(GET_USER, fetchUsers)
  yield takeEvery(GET_USERS_BY_ID, fetchUsersById)
  yield takeEvery(UPDATE_USER, updateUsersById)
  yield takeEvery(GET_AUTHOR, fetchAuthor)
  yield takeEvery(GET_CRAFTSMAN, fetchCraftsman)
  yield takeEvery(ADD_USER, createUsers)
  yield takeEvery(ON_CHECKED_AUTHOR, checkedAuthor)
  yield takeEvery(ON_CHECKED_CRAFTSMAN, checkedCraftsman)
  yield takeEvery(SET_CRAFTSMAN, setCraftsmanSaga)
}

export default usersSaga
